export default __webpack_public_path__ + "static/media/phantom.c0926fa7.png";